<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <br/>
          <p v-if="labels" @click="showModal('genouillere')">
            Quelques exemples de genouillères que l'on peut vous proposer.
            <v-icon color="black darken-2" dark small>
              mdi-image-multiple
            </v-icon>
          </p>
          <p v-else-if="flux.level2 === 'PANTALON / SALOPETTE TECHNIQUE'">
            Nous recouvrons les genoux avec un tissu adapté.
          </p>
          <p v-else>Les genouillères sont réalisées dans un textile rapprochant de forme rectangulaire</p>
        </v-col>
      </v-row>
      <v-form
          ref="form"
          lazy-validation
      >
        <v-row>
          <v-col cols="12">
            Nombre de trou
            <plus-minus-field
                :index="0"
                :max="9"
                :min="1"
                :price="price"
                :value="quantity"
                @input="e => getInfos(e)"
            />
          </v-col>
          <v-col v-if="labels" cols="12">
            <v-radio-group v-model="genouillere_couleur" :rules="requireRules">
              <v-radio
                  v-for="(label, index) in labels"
                  :key="index"
                  :label="label.label"
                  :value="label.value"
                  @click="getPrice()"
              />
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <image-preview
                :is-bonus-eligible="totalBonus > 0"
                :value="pictures"
                @change="v => pictures = v"
            />
          </v-col>
          <price :amount="totalPrice" :bonus="totalBonus" :display-bottom-line="!!genouillere_couleur"/>
        </v-row>
        <bonus-image-confirm
            v-if="totalPrice > 0 && totalBonus > 0 && pictures.length < 2"
            @skip-bonus="totalBonus = 0"
        />
        <confirm-flow
            v-else-if="totalPrice > 0 && !this.flux.indexEditProduit"
            @finalize="noarticle"
            @new-repair="onSelectNewRepair"
            @new-article="noarticle(false)"
        />
        <v-row v-else-if="this.flux.indexEditProduit">
          <v-col v-if="error" cols="12">
            <div class="text-center" style="color:#FF0000">Vous devez effectuer un choix de genouillères
            </div>
          </v-col>
          <v-col class="text-center" cols="12">
            <div class="btn btn-1 text-center btn-size" @click="noarticle">MODIFIER</div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>
<script>
import trouPrice from '../../assets/data/price/genouilleres.json';

import {mapMutations, mapState} from 'vuex'
import Price from "@/components/shared/Price.vue";
import ImagePreview from "@/components/interface/ImagePreview.vue";
import BonusImageConfirm from "@/components/shared/BonusImageConfirm.vue";
import ConfirmFlow from "@/components/shared/ConfirmFlow.vue";
import PlusMinusField from "@/components/interface/PlusMinusField.vue";

let liste_reparations = []

export default {
  data() {
    return {
      labels: [],
      price: 0,
      bonus: 0,
      totalPrice: 0,
      totalBonus: 0,
      quantity: 1,
      pictures: [],
      genouillere_couleur: null,
      error: false,
      requireRules: [
        v => !!v || 'Ce champs est requis'
      ]
    }
  },
  computed: {
    ...mapState('cart-app', ['cards', 'products']),
    ...mapState('flux-app', ['flux']),
  },
  created() {
    if (this.flux.activeTab !== 'genouillere') {
      return null;
    }
    this.labels = trouPrice[0][this.flux.level2].labels
    if (this.flux.level2 && this.flux.verrou === false && this.flux.indexEditProduit !== null) {
      this.setVerrou(true)
      this.totalPrice = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['price']
      this.genouillere_couleur = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['genouillere_couleur']

    }
    if (!this.labels) {
      this.getPrice()
    }
  },
  updated() {
    if (this.flux.activeTab !== 'genouillere') {
      return null;
    }
    if (this.flux.level2) {
      this.labels = trouPrice[0][this.flux.level2].labels
      this.tabPromotions = trouPrice[0][this.flux.level2].promotions
    }

    if (this.flux.level2 && this.flux.verrou === false && this.flux.indexEditProduit !== null) {
      this.setVerrou(true)
      this.totalPrice = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['price']
      this.genouillere_couleur = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['genouillere_couleur']
    }
  },
  methods: {
    ...mapMutations('flux-app', ['setConstat', 'incrementCptProduct', 'setcptReparation', 'setVerrou', 'setLevel1', 'setLevel2', 'setLevel3', 'setComponentName']),
    ...mapMutations('cart-app', ['addProduct', 'getTotalCart']),
    noarticle(showCart = true) {
      console.log({showCart})
      if (this.totalPrice <= 0) {
        this.error = true;
      } else if (this.$refs.form.validate()) {
        if (this.flux.indexEditProduit !== null) { //Mode Edit
          this.editProduct();
          this.setLevel1(null)
          this.setLevel2(null)
          this.setLevel3(null)
          this.setComponentName(null)
        } else {
          this.storeProduct()
          this.incrementCptProduct()
          liste_reparations = []
          this.setcptReparation(0)
        }

        this.$emit('evenement', 'scroll1')

        if (showCart) {
          this.setConstat('cart')
          this.$emit('showmodal', 'cart')
        }
      }
    },
    onSelectNewRepair() {
      this.storeProduct()
      this.$emit('evenement', 'scroll3')
    },
    editProduct() {
      liste_reparations = this.products[this.flux.indexEditProduit].reparations
      //On check l'historique des réparations
      let index = liste_reparations.findIndex((obj => obj.id == (this.flux.indexEditReparation + 1)));
      if (index > -1) {
        let reparation = {
          id: liste_reparations[index].id,
          activeTab: 'genouilleres',
          type: 'genouilleres',
          componentName: 'trou-accroc-dechirure',
          qte: this.quantity,
          genouillere_couleur: this.genouillere_couleur,
          price: this.totalPrice,
          bonus: this.pictures.length > 1 ? this.totalBonus : 0,
          pictures: this.pictures
        }

        this.products[this.flux.indexEditProduit].reparations.splice(index, 1, reparation)
        let data = {
          idLevel1: this.products[this.flux.indexEditProduit].idLevel1,
          level1: this.products[this.flux.indexEditProduit].level1,
          level2: this.products[this.flux.indexEditProduit].level2,
          level3: this.products[this.flux.indexEditProduit].level3,
          isDouble: this.products[this.flux.indexEditProduit].isDouble,
          id: this.products[this.flux.indexEditProduit].id,
          name: this.products[this.flux.indexEditProduit].name,
          famille: this.products[this.flux.indexEditProduit].famille,
          reparations: liste_reparations
        }


        this.addProduct(data)
        this.getTotalCart(this.products)
        this.$emit('evenement', 'scroll3')

      }
    },
    storeProduct() {
      if (this.totalPrice <= 0) {
        this.error = true;
      } else if (this.$refs.form.validate()) {
        this.setcptReparation(this.flux.cptReparation + 1)

        if (this.flux.cptProduct < 1) {
          this.incrementCptProduct()
        }

        //On check l'historique des réparations
        liste_reparations = []
        let index = this.products.findIndex((obj => obj.id == this.flux.cptProduct));
        if (index > -1) {
          liste_reparations = this.products[index].reparations
        }

        let reparation = {
          id: this.flux.cptReparation,
          activeTab: this.flux.activeTab,
          type: 'genouilleres',
          componentName: 'trou-accroc-dechirure',
          qte: this.quantity,
          genouillere_couleur: this.genouillere_couleur,
          price: this.totalPrice,
          bonus: this.pictures.length > 1 ? this.totalBonus : 0,
          pictures: this.pictures
        }

        liste_reparations.push(reparation)

        let data = {
          idLevel1: this.flux.idLevel1,
          level1: this.flux.level1,
          level2: this.flux.level2,
          level3: this.flux.level3,
          isDouble: this.flux.isDouble,
          id: this.flux.cptProduct,
          name: this.flux.level2,
          famille: this.flux.level1,
          reparations: liste_reparations
        }
        this.addProduct(data)
        this.getTotalCart(this.products)
        this.setLevel3(null)
        this.setComponentName(null)
      }
    },
    resetPrice() {
      this.totalPrice = 0
    },
    getInfos(value) {
      this.quantity = value[1]
      this.getPrice()
    },
    getPrice() {
      this.price = trouPrice[0][this.flux.level2]['prix']
      this.bonus = trouPrice[0][this.flux.level2]?.bonus?.[this.flux.isDouble ? 'double' : 'non_double'] ?? 0

      this.totalPrice = this.price * this.quantity
      this.totalBonus = this.bonus * this.quantity

      if (this.flux.isDouble) {
        this.totalPrice *= 1.2
      }
      this.price = Math.round(this.price * 100) / 100
      this.error = false
    },
    showModal(constat) {
      this.setConstat(constat)
      this.$emit('showmodal')
    }
  },
  components: {ConfirmFlow, BonusImageConfirm, ImagePreview, Price, PlusMinusField}
}
</script>
